import { WidgetContainer } from '@pulse-web-ui/containers';
import { css, media, styled, typography } from '@pulse-web-ui/theme';

type JustifyContentType =
  'start' | 'center' | 'space-between' | 'space-around' | 'space-evenly';

type AlignContentType =
  | 'self-start'
  | 'self-end'
  | 'baseline'
  | 'stretch'
  | 'flex-start'
  | 'flex-end'
  | 'center';

export const FormControlContainer = styled.div<{
  $margin?: string;
  $width?: string;
}>`
  width: ${({ $width }) => $width ?? '100%'};
  margin-bottom: 12px;

  ${({ $margin }) =>
    $margin &&
    css`
      margin: ${$margin};
    `}
`;

export const TabsContainer = styled.div<{
  $marginBottom?: number;
}>`
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 8}px;
`;

export const StepsListContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  padding: 0 16px;
  box-sizing: border-box;
  margin-bottom: 16px;

  ${media.desktop} {
    max-width: 768px;
    padding: 0;
  }
`;

export const ColumnContainer = styled.div<{
  $gap?: number;
  $marginBottom?: number;
  $align?: AlignContentType;
  $padding?: [number, number];
}>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap ?? 8}px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 0}px;
  ${({ $align }) => $align && `align-items: ${$align}`};
  ${({ $padding }) => $padding && `padding: ${$padding?.join('px ')}px`};
`;

export const ContainerWithPadding = styled.div<{
  $margin?: string;
  $padding?: [number, number];
}>`
  width: 100%;
  max-width: 768px;
  padding: ${({ $padding }) => $padding?.join('px ') ?? '0px 16px'};
  box-sizing: border-box;

  ${({ $margin }) =>
    $margin &&
    css`
      margin: ${$margin};
    `}
`;

export const RowContainer = styled.div<{
  $justify?: JustifyContentType;
  $align?: AlignContentType;
  $gap?: number;
  $marginBottom?: number;
  $wrap?: string;
}>`
  display: flex;
  justify-content: ${({ $justify }) => $justify ?? 'start'};
  align-items: ${({ $align }) => $align ?? 'center'};
  gap: ${({ $gap }) => $gap ?? 0}px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 24}px;
  flex-wrap: ${({ $wrap }) => $wrap ?? 'wrap'};
  width: 100%;
`;

export const SmallWidgetContainer = styled(WidgetContainer)`
  ${media.desktop} {
    max-width: 400px;
  }
`;

export const TwoColumnContainer = styled.div<{
  $marginBottom?: number;
}>`
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 24}px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${media.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
    row-gap: 16px;
  }
`;

export const MonthDatepickerContainer = styled.div`
  ${({ theme }) => theme.common['box-shadow']};
  box-sizing: border-box;
  width: 328px;
  min-height: 230px;
  padding: 20px 16px 0;
  color: ${({ theme }) => theme.colors.text.primary};
  border-radius: ${({ theme }) => theme.common.radiusS};

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__time-container {
    display: none;
  }

  .react-datepicker__navigation--previous {
    top: 12px;
    left: 8px;
  }

  .react-datepicker__navigation--next {
    top: 12px;
    right: 8px !important;
  }

  .react-datepicker__month-text {
    ${typography.regular16}
    width: 4.3rem !important;
    padding: 6px;
    margin: 4px 8px !important;
    user-select: none;
    text-transform: capitalize;

    :not(
      .react-datepicker__month-text--disabled,
      .react-datepicker__month-text--selected,

    ) {
      color: ${({ theme }) => theme.colors.text.primary};
    }

    :hover:not(
      .react-datepicker__month-text--disabled,
      .react-datepicker__month-text--selected,
      .react-datepicker__month-text--keyboard-selected
    ) {
      background-color: ${({ theme }) => theme.colors.neutral[10]};
      border-radius: ${({ theme }) => theme.common.radiusS};
    }
  }

  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--keyboard-selected {
    background: ${({ theme }) => theme.colors.accent.action.normal} !important;
    color: ${({ theme }) => theme.colors['on-accent'].primary};
    border-radius: ${({ theme }) => theme.common.radiusXS};
  }

  .react-datepicker__month-text--selected:hover {
    background: ${({ theme }) => theme.colors.accent.action.darkened};
    border-radius: ${({ theme }) => theme.common.radiusXS};
  }

  .react-datepicker__header {
    background: ${({ theme }) => theme.colors.neutral[0]};
    border: none;
    padding: 0;
    margin-bottom: 12px;
  }
`;
